import { useEffect, useRef } from "react";

/** Refetch on mount, on a fixed interval, and when the tab becomes visible only if data is stale. */
export const usePeriodicRefetch = (refetch: () => void | Promise<void>, intervalMs: number) => {
  const lastRefetchAt = useRef(0);

  useEffect(() => {
    const runRefetch = () => {
      lastRefetchAt.current = Date.now();
      void refetch();
    };

    const maybeRefetchOnVisible = () => {
      if (document.visibilityState !== "visible") return;
      if (Date.now() - lastRefetchAt.current < intervalMs) return;
      runRefetch();
    };

    runRefetch();

    const timer = window.setInterval(runRefetch, intervalMs);
    document.addEventListener("visibilitychange", maybeRefetchOnVisible);

    return () => {
      window.clearInterval(timer);
      document.removeEventListener("visibilitychange", maybeRefetchOnVisible);
    };
  }, [refetch, intervalMs]);
};
